import Box from '@mui/material/Box'

export default function AuthLogo() {

    return (
        <Box component={"img"}           
            width="auto"
            height="64px"
            loading="lazy"
            alt="Solar Zero Logo"
            src="/images/szNamedLogo.svg" />
    )
}